import React from 'react';


 function Splash(props) {
    return (
        <div className={`splash abs abc`}>
         
        </div>
    );
}

export  default Splash;